<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M6.75 3a.75.75 0 0 0-1.5 0v2.5c0 1.3.91 2.4 2.14 2.68l-1.3 1.46a3.75 3.75 0 0 0-.15 4.79l5.47 7.03a.75.75 0 0 0 1.18 0l5.47-7.03a3.75 3.75 0 0 0-.16-4.8l-1.29-1.45a2.75 2.75 0 0 0 2.14-2.68V3a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25V3Zm.47 7.63 2.12-2.38h5.32l2.12 2.38c.72.81.76 2.02.1 2.88l-4.13 5.3V13.3a1.5 1.5 0 1 0-1.5 0v5.51l-4.13-5.3a2.25 2.25 0 0 1 .1-2.88Z"
		fill="currentColor"
	/>
</svg>
